shvenergy.breadcrumb = (function ($) {
	"use strict";

	function init() {

		var breadCrumbItems = $(".breadcrumb ul li");
		var breadCrumbWidth = 0;
		breadCrumbItems.each(function () {
			var w = $(this).outerWidth(true);
			breadCrumbWidth += w;
		});

		$(".breadcrumb ul").scrollLeft(breadCrumbWidth).on('scroll', function () {
			var $that = $(this),
				klass = 'repaint';

			$that.addClass(klass);
			setTimeout(function () {
				$that.removeClass(klass);
			}, 0);
		});
		
    }

	init();

})(jQuery);